import { render, staticRenderFns } from "./CStatus.vue?vue&type=template&id=68436750&"
import script from "./CStatus.vue?vue&type=script&lang=js&"
export * from "./CStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports